export const message = (value) => {
	if (value && value.length < 5) {
		return 'Please enter your message';
	}
};
